import { gql } from 'apollo-angular';

export const DeletePostDocument = gql`
  mutation deletePost($id: String!) {
    deletePost(id: $id)
  }
`;
